import React, {ReactElement} from 'react';
import {Button, CloudDownloadIcon} from '@customink/pigment-react';
import services from '../../api/remoteServices';
import Tooltip from '../CustomTooltip';

type PurchaseItemsCsvExportButtonProps = {
  storeSlug: string;
};

const PurchaseItemsCsvExportButton: React.FC<PurchaseItemsCsvExportButtonProps> =
  ({storeSlug}: PurchaseItemsCsvExportButtonProps): ReactElement => {
    return (
      <div className="purchaseItemsCsvExportButton-container">
        <Tooltip title="Download CSV" arrow placement="bottom-end">
          <span className="purchaseItemsCsvExportButton-container-actions">
            <Button
              className="purchaseItemsCsvExportButton-container-actions-button"
              aria-label="downloadPurchaseItemsCsv"
              startIcon={<CloudDownloadIcon />}
              size="small"
              variant="link"
              href={`${services.stores}/api/stores/${storeSlug}/purchase_items/export.csv`}
              role="link"
            />
          </span>
        </Tooltip>
      </div>
    );
  };

export default PurchaseItemsCsvExportButton;
